import { defineComponent, openBlock, createElementBlock, Fragment, renderList, createBlock, unref, withCtx, createTextVNode, toDisplayString, createVNode, createElementVNode } from "vue";
import { CdrLink, IconExternalLink } from "@rei/cedar";
const _hoisted_1 = {
  class: "product-manuals"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductManuals",
  props: {
    userManuals: {}
  },
  emits: ["metricsClick"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.userManuals, (doc) => {
        return openBlock(), createBlock(unref(CdrLink), {
          key: doc.id,
          href: doc.uri,
          class: "product-manuals__link",
          target: "_blank",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("metricsClick", {
            linkName: "instructions-manuals"
          }))
        }, {
          default: withCtx(() => [createTextVNode(toDisplayString(doc.title || `User Manual`) + " ", 1), createVNode(unref(IconExternalLink), {
            "inherit-color": "",
            class: "product-manuals__icon"
          }), _cache[1] || (_cache[1] = createElementVNode("span", {
            class: "pdp-sr-only"
          }, ", opens in new window", -1))]),
          _: 2,
          __: [1]
        }, 1032, ["href"]);
      }), 128))]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductManuals2.mjs.map
